<template>
  <div class="relative" ref="dropdownRef">
    <!-- Trigger Slot -->
    <slot name="trigger" :toggle="toggleDropdown" :is-open="isOpen" />

    <!-- Dropdown Panel -->
    <Transition
      enter-active-class="transition ease-out duration-200"
      enter-from-class="opacity-0 translate-y-1"
      enter-to-class="opacity-100 translate-y-0"
      leave-active-class="transition ease-in duration-150"
      leave-from-class="opacity-100 translate-y-0"
      leave-to-class="opacity-0 translate-y-1"
    >
      <div
        v-if="isOpen"
        class="absolute bg-bg-canvas top-full mt-2 z-50 min-w-[280px] max-h-[260px] overflow-scroll no-scrollbar rounded-2xl shadow-filter-dropdown border border-outline-dividers p-2.5 flex flex-col gap-1"
        :class="[alignmentClass]"
      >
        <!-- Content Slot -->
        <slot :close="closeDropdown" />
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue";

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
  dropdownAlign: {
    type: String,
    default: "right",
    validator: (value) => ["left", "right"].includes(value),
  },
});

const emit = defineEmits(["toggle", "close"]);

const dropdownRef = ref(null);

const alignmentClass = computed(() => {
  return props.dropdownAlign === "left" ? "left-0" : "right-0";
});

function toggleDropdown() {
  emit("toggle");
}

function closeDropdown() {
  emit("close");
}

function handleClickOutside(event) {
  if (event.target.closest('[data-slot="calendar"]')) return;

  if (props.isOpen && dropdownRef.value && !dropdownRef.value.contains(event.target)) {
    closeDropdown();
  }
}

onMounted(() => {
  document.addEventListener("click", handleClickOutside, true);
});

onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside, true);
});
</script>
